<template>
  <div class="devicesPage">
    <el-table stripe :data="tableData" border style="width: 100%" height="100%" size="mini"
      @sort-change="sortChange" @selection-change="handleSelectionChange">
      <el-table-column type="selection" width="39" />
      <el-table-column type="index" :width="pagination.endIndex >= 1000 ? 80 : 50" align="center" :index="pagination.beginIndex"/>
      <el-table-column prop="sn" label="SN" align="center" sortable="custom">
        <template slot-scope="scope">
          <div class="bodyCell">
            <el-tooltip class="item" effect="dark" :content="scope.row.sn ? scope.row.sn : '【未生成SN】'" placement="top" min-width="110px" :open-delay="300">
              <div class="textOverflow allowSkip" @click="SNClickBtn($event, scope.row)">
                {{ scope.row.sn ? scope.row.sn : "【未生成SN】" }}
              </div>
            </el-tooltip>
            <el-tooltip
              v-if="scope.row.sn"
              effect="dark"
              content="已将SN复制到剪贴板"
              placement="top"
              manual
              v-model="scope.row.copySnTip">
              <i class="el-icon-document-copy copyBtn" title="复制" @click="copyCell(scope.row, 'sn', 'copySnTip')"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="pcbaSn" label="PCBA" align="center" sortable="custom">
        <template slot-scope="scope">
          <div class="bodyCell">
            <el-tooltip v-if="scope.row.pcbaSn" class="item" effect="dark" :content="scope.row.pcbaSn" placement="top" min-width="135px" :open-delay="300">
              <div class="textOverflow">
                {{ scope.row.pcbaSn }}
              </div>
            </el-tooltip>
            <span v-if="!scope.row.pcbaSn">-</span>
            <el-tooltip
              v-if="scope.row.pcbaSn"
              effect="dark"
              content="已将PCBA复制到剪贴板"
              placement="top"
              manual
              v-model="scope.row.copyPcbaTip">
              <i class="el-icon-document-copy copyBtn" title="复制" @click="copyCell(scope.row, 'pcbaSn', 'copyPcbaTip')"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="mac" label="MAC" align="center">
        <template slot-scope="scope">
          <div class="bodyCell">
            <el-tooltip class="item" effect="dark" placement="top" min-width="110px" :open-delay="300">
              <div slot="content" style="white-space: pre-wrap; word-break: break-all;">{{ JSON.stringify(scope.row.mac, null, 2) }}</div>
              <div class="textOverflow" v-if="scope.row.mac">
                {{ scope.row.mac }}
              </div>
            </el-tooltip>
            <span v-if="!scope.row.mac">-</span>
            <el-tooltip
              v-if="scope.row.mac"
              effect="dark"
              content="已将MAC复制到剪贴板"
              placement="top"
              manual
              v-model="scope.row.copyMacTip">
              <i class="el-icon-document-copy copyBtn" title="复制" @click="copyCell(scope.row, 'mac', 'copyMacTip')"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="otherSn" label="UUID" align="center">
        <template slot-scope="scope">
          <div class="bodyCell">
            <el-tooltip class="item" effect="dark" :content="scope.row.uuid" placement="top" min-width="110px" :open-delay="300">
              <div class="textOverflow" v-if="scope.row.uuid">
                {{ scope.row.uuid }}
              </div>
            </el-tooltip>
            <span v-if="!scope.row.uuid">-</span>
            <el-tooltip
              v-if="scope.row.uuid"
              effect="dark"
              content="已将UUID复制到剪贴板"
              placement="top"
              manual
              v-model="scope.row.copyUuidTip">
              <i class="el-icon-document-copy copyBtn" title="复制" @click="copyCell(scope.row, 'uuid', 'copyUuidTip')"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="otherSn" label="其它SN" align="center">
        <template slot-scope="scope">
          <div class="bodyCell">
            <el-tooltip v-if="scope.row.otherSn" class="item" effect="dark" placement="top" min-width="110px" :open-delay="300">
              <div slot="content" style="white-space: pre-wrap; word-break: break-all;">{{ JSON.stringify(scope.row.otherSn, null, 2) }}</div>
              <div class="textOverflow">
                {{ scope.row.otherSn }}
              </div>
            </el-tooltip>
            <span v-else>-</span>
            <el-tooltip
              v-if="scope.row.otherSn"
              effect="dark"
              content="已将其它SN复制到剪贴板"
              placement="top"
              manual
              v-model="scope.row.copyOtherSnTip">
              <i class="el-icon-document-copy copyBtn" title="复制" @click="copyCell(scope.row, 'otherSn', 'copyOtherSnTip')"></i>
            </el-tooltip>
          </div>
        </template>
      </el-table-column>
      <el-table-column prop="weight" label="称重" align="center" width="90px">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.weight" placement="top" class="item" effect="dark">
            <div slot="content" style="white-space: pre-wrap; word-break: break-all;">{{ JSON.stringify(scope.row.weight, null, 2) }}</div>
            <div class="textOverflow" v-if="scope.row.weight">
              {{ scope.row.weight }}
            </div>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="innerCtnIndex" label="内箱" align="center" width="90px" show-overflow-tooltip>
        <template slot-scope="scope">
          <template v-if="scope.row.innerCtnSn">
            <el-tooltip class="item" effect="dark" :content="scope.row.innerCtnSn" placement="top" :open-delay="300">
              <span class="textOverflow allowSkip">
                {{ scope.row.innerCtnIndex }}
              </span>
            </el-tooltip>
          </template>
          <template v-else-if="scope.row.innerCtnIndex">
            <span>
              {{ scope.row.innerCtnIndex }}
            </span>
          </template>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="innerCtnIndex" label="外箱" align="center" width="90px" show-overflow-tooltip>
        <template slot-scope="scope">
          <template v-if="scope.row.outerCtnSn">
            <el-tooltip class="item" effect="dark" :content="scope.row.outerCtnSn" placement="top" :open-delay="300">
              <div class="textOverflow">
                {{ scope.row.outerCtnIndex }}
              </div>
            </el-tooltip>
          </template>
          <template v-else-if="scope.row.outerCtnIndex">
            <span>
              {{ scope.row.outerCtnIndex }}
            </span>
          </template>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column prop="testTimes" label="测试次数" align="center" width="105px"
        sortable="custom">
        <template slot-scope="scope">
          <span class="textOverflow">{{ scope.row.testTimes }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="failTimes" label="错误次数" align="center" width="105px"
        sortable="custom">
        <template slot-scope="scope">
          <span class="textOverflow">{{ scope.row.failTimes }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="workStationId" label="状态" align="center" sortable="custom" width="95px">
        <template slot-scope="scope">          
          <el-tooltip v-if="scope.row.notes" class="item" effect="dark" :content="scope.row.notes" placement="top" min-width="110px" :open-delay="300">
            <div class="textOverflow" :style="{color: scope.row.workStation.id < -1 ? '#F56C6C' : ''}">
              {{ scope.row.workStation.name }}
            </div>
          </el-tooltip>
          <span v-else class="textOverflow" :style="{color: scope.row.workStation.id < -1 ? '#F56C6C' : ''}">{{ scope.row.workStation.name }}</span>
        </template>
      </el-table-column>
      <el-table-column prop="notes" label="备注" align="center">
        <template slot-scope="scope">
          <el-tooltip v-if="scope.row.notes" class="item" effect="dark" :content="scope.row.notes" placement="top" :open-delay="800">
            <div class="textOverflow">{{ scope.row.notes }}</div>
          </el-tooltip>
          <span v-else>-</span>
        </template>
      </el-table-column>
      <el-table-column class-name="operation" label="操作" align="center" width="115px">
        <template slot-scope="scope">
          <!-- // 已发货的不能锁定 -->
          <span v-if="scope.row.workStation && (scope.row.workStation.id=='36226401431584768' || scope.row.workStation.id=='-3' || scope.row.workStation.id=='-10')"
          > - </span>
          <el-tooltip v-if="scope.row.workStation && scope.row.workStation.id!='-999' && scope.row.workStation.id!='36226401431584768' && scope.row.workStation.id>='-1' && scope.row.workStation.id!='-3' && scope.row.workStation.id!='-10'" class="item" effect="dark" content="回退至上一工序(仅限组装段工序)" placement="top" :open-delay="300">
            <i @click="rollbackSop($event, scope.row)" class="iconfont icon-huitui"></i>
          </el-tooltip>
          <el-tooltip v-if="scope.row.workStation && scope.row.workStation.id!='36226401431584768' && scope.row.workStation.id!='-999' && scope.row.workStation.id!='-3' && scope.row.workStation.id!='-10'"
            class="item" effect="dark" content="异常锁定" placement="top" :open-delay="300">
            <i @click="lockDevice($event, scope.row)" class="el-icon-lock"></i>
          </el-tooltip>
          <el-tooltip v-if="scope.row.workStation && scope.row.workStation.id=='-999'"
            class="item" effect="dark" content="解锁异常" placement="top" :open-delay="300">
            <i @click="unlockDevice($event, scope.row)" class="el-icon-unlock"></i>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.workStation && scope.row.workStation.id!='-999' && scope.row.workStation.id!='36226401431584768' && scope.row.workStation.id>='-1' && scope.row.workStation.id!='-3' && scope.row.workStation.id!='-10'"
            class="item" effect="dark" content="借出" placement="top" :open-delay="300">
            <i @click="lendOutDevice($event, scope.row)" class="iconfont icon-jiechu">&nbsp;</i>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.workStation && scope.row.workStation.id=='-3'"
            class="item" effect="dark" content="归还" placement="top" :open-delay="300">
            <i @click="lockDevice($event, scope.row)" class="iconfont icon-guihuan">&nbsp;</i>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.workStation && scope.row.workStation.id!='36226401431584768' && scope.row.workStation.id>='-1' && scope.row.workStation.id!='-999' && scope.row.workStation.id!='-10' && scope.row.workStation.id!='-3'"
            class="item" effect="dark" content="送修" placement="top" :open-delay="300">
            <i @click="lockDevice($event, scope.row)" class="iconfont icon-weixiu">&nbsp;</i>
          </el-tooltip>
          <el-tooltip
            v-if="scope.row.workStation && scope.row.workStation.id=='-112'"
            class="item" effect="dark" content="修完" placement="top" :open-delay="300">
            <i @click="lockDevice($event, scope.row)" class="iconfont icon-reset-device"></i>
          </el-tooltip>
          <el-tooltip class="item" effect="dark" content="添加备注" placement="top" :open-delay="300">
            <i @click="addNotes($event, scope.row)" class="iconfont icon-pizhu"></i>
          </el-tooltip>
        </template>
      </el-table-column>
    </el-table>
    <pagination :pagination="pagination"
      @currentChange="currentChange" @sizeChange="sizeChange" @refreshBtn="getProductionOrderDevices"></pagination>
    <myDrawer ref="myDrawer" :drawerOption="drawerOption"></myDrawer>    
    <myDialog ref="myDialog" :title="dialogTitle" @submitData="submitData" @dialogClose="dialogClose" width="450px">
      <template slot="content">
        <el-form :model="dialogForm" :rules="dialogRules" ref="dialogForm" label-width="50px">
          <div v-if="dialogTitle === '添加备注'">            
            <el-form-item label="备注：" size="small" prop="notes">
              <el-input type="textarea"
                        :autosize="{minRows: 3, maxRows: 20}"
                        v-model="dialogForm.value"
                        placeholder="备注内容(只添加不修改)"
                        clearable
              ></el-input>
            </el-form-item>
          </div>
        </el-form>
      </template>
    </myDialog>
  </div>
</template>

<script>
import pagination from "@/components/pagination.vue";
import {
  apiProductionOrderDevices,
  apiExportShipmentOrder,
  apiExportMacs,
  apiProductionOrderSopRollback,
  apiProductionOrderLockDevice,
  apiProductionOrderLendOutDevice,
  apiProductionOrderUnlockDevice,
  apiProductionOrderBatchLockDevice, apiProductionOrderBatchUnlockDevice
} from "@/api/productionOrder.js";
import {
  apiAddNotes
} from "@/api/deviceManage.js";
import myDrawer from "@/components/myDrawer.vue";
import myDialog from "@/components/myDialog.vue";
export default {
  components: {
    pagination,
    myDrawer,
    myDialog
  },
  props: {
    tabPaneValue: {
      type: String,
    },
    devicesSearchForm: {
      type: Object,
    },
  },
  data() {
    return {
      tableData: [],
      desc: undefined,
      orderBy: [],
      pagination: {
        currentPage: 1,
        pageSize: 40,
        total: 102,
        beginIndex: 1,
        endIndex: 10,
      },
      drawerOption: {
        currentSNId: "",
        currentSNName: "",
      },
      multipleSelection: [],
      batchSNStr: "",
      productionOrderIds:[],
      dialogTitle: "",
      dialogForm: {},
      dialogRules: {},
      batchDeviceIds: [],
      copyTimers: {}
    };
  },
  methods: {
    // 回退工序
    rollbackSop(e,row) {
      e.target.blur();
      this.$allOperation({ name: row.workStation.name }, "回退", "工序").then(
        async () => {
          const res = await apiProductionOrderSopRollback({
            id: row.workStation.id,
            deviceId: row.id,
          });
          // console.log(res)
          if (res.code == 0) {
            this.getProductionOrderDevices();
            this.$message({
              message: "回退成功",
              type: "success",
            });
          }
        }
      );
    },
    addNotes(e, row) {
      this.dialogTitle = "添加备注";
      this.$refs.myDialog.dialogVisible = true;
      this.dialogForm = {
        id: row.id
      };
    },
    submitData(title) {
      this.$refs.dialogForm.validate(async (valid) => {
        if (valid) {
          let res = {};
          if (title === "添加备注") {
            res = await apiAddNotes(this.dialogForm);
          }
          if (res.code === 0) {
            this.$message({
              message: "添加成功！",
              type: "success",
            });
            this.$refs.myDialog.dialogVisible = false;
            await this.getProductionOrderDevices();
          }
        }
      });
    },
    // 关闭对话框
    dialogClose() {
      this.$refs.dialogForm.resetFields();
      this.dialogForm = {};
    },
    // 借出产品
    lendOutDevice(e, row) {
      e.target.blur();
      const h = this.$createElement;
      const tt = row.sn ? "请输入SN：【" : "请输入工单号:【";
      const st = row.sn ? row.sn : row.productionOrder.orderNumber;
      this.$msgbox({
        title: `产品借出确认`,
        message: h("div", null, [
          h("span", null, tt),
          h("i", { style: "color: var(--themeColor)" }, st),
          h("span", null, "】以确认借出产品！"),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == st) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiProductionOrderLendOutDevice({
          id: row.productionOrder.id,
          deviceId: row.id
        });
        if (res.code == 0) {
          this.getProductionOrderDevices();
          this.$message({
            type: "success",
            message: "产品借出成功！"
          });
        }
      });
    },
    // 锁定产品
    lockDevice(e, row) {
      e.target.blur();
      const h = this.$createElement;
      const tt = row.sn ? "请输入SN：【" : "请输入工单号:【";
      const st = row.sn ? row.sn : row.productionOrder.orderNumber;
      this.$msgbox({
        title: `警告：产品锁定后将被生产拦截！`,
        message: h("div", null, [
          h(
            "span",
            null,
            tt
          ),
          h("i", { style: "color: var(--themeColor)" }, st),
          h("span", null, `】以确认锁定产品！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == st) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiProductionOrderLockDevice({
          id: row.productionOrder.id,
          deviceId: row.id
        });
        if (res.code == 0) {
          this.getProductionOrderDevices();
          this.$message({
            type: "success",
            message: "产品锁定成功，该产品将被生产拦截！"
          });
        }
      });
    },
    //批量锁定产品
    batchLockDevice() {
      this.productionOrderIds = [];
      this.batchDeviceIds = [];
      let st;
      let _this = this;
      // eslint-disable-next-line no-unused-vars
      let _productionOrderId;
      this.multipleSelection.forEach(function (item){
        _this.productionOrderIds.push(item.productionOrder.id);
        _this.batchDeviceIds.push(item.id);
        st = item.productionOrder.orderNumber;
      });

      if(this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "未选择需要锁定的SN号！"
        });
        return;
      }
      _this.productionOrderIds.some(function (value){
        if(value == _this.productionOrderIds[0]){
          _productionOrderId = value;
        }else{
          this.$message({
            type: "warning",
            message: "选择的产品不一致 ！"
          });
          return;
        }
      });
      const h = this.$createElement;
      const tt = "请输入工单号:【";
      this.$msgbox({
        title: `警告：产品锁定后将被生产拦截！`,
        message: h("div", null, [
          h(
              "span",
              null,
              tt
          ),
          h("i", { style: "color: var(--themeColor)" }, st),
          h("span", null, `】以确认锁定产品！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == st) {
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiProductionOrderBatchLockDevice({
          id: _productionOrderId,
          deviceIds: this.batchDeviceIds
        });
        if (res.code == 0) {
          this.getProductionOrderDevices();
          this.$message({
            type: "success",
            message: "产品锁定成功，状态为异常锁定的产品将被生产拦截！"
          });
        }
      });
    },
    //批量解锁产品
    batchUnLockDevice() {
      this.productionOrderIds = [];
      this.batchDeviceIds = [];
      let st;
      let _this = this;
      let _productionOrderId;
      this.multipleSelection.forEach(function (item){
        _this.productionOrderIds.push(item.productionOrder.id);
        _this.batchDeviceIds.push(item.id)
        st = item.productionOrder.orderNumber;
      });

      if(this.multipleSelection.length == 0) {
        this.$message({
          type: "warning",
          message: "未选择需要解锁的SN号！"
        });
        return;
      }
      _this.productionOrderIds.some(function (value){
        if(value == _this.productionOrderIds[0]){
          _productionOrderId = value;
        }else{
          this.$message({
            type: "warning",
            message: "选择的产品不一致 ！"
          });
          return;
        }
      });

      const h = this.$createElement;
      const tt = "请输入工单号:【";
      this.$msgbox({
        title: `温馨提示：解锁后产品将回到【待生产】状态`,
        message: h("div", null, [
          h(
              "span",
              null,
              tt
          ),
          h("i", { style: "color: var(--themeColor)" }, st),
          h("span", null, `】以确认解锁产品！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == st || instance.inputValue.indexOf("-")==0) {
              st = instance.inputValue;
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiProductionOrderBatchUnlockDevice({
          id: _productionOrderId,
          deviceIds: this.batchDeviceIds,
          newSn: st
        });
        if (res.code == 0) {
          this.getProductionOrderDevices();
          this.$message({
            type: "success",
            message: res.msg
          });
        }
      });
    },
    // 解锁产品
    unlockDevice(e, row) {
      e.target.blur();
      const h = this.$createElement;
      const tt = row.sn ? "请输入SN：【" : "请输入工单号:【";
      var st = row.sn ? row.sn : row.productionOrder.orderNumber;
      this.$msgbox({
        title: `温馨提示：解锁后产品将回到【待生产】状态`,
        message: h("div", null, [
          h(
            "span",
            null,
            tt
          ),
          h("i", { style: "color: var(--themeColor)" }, st),
          h("span", null, `】以确认解锁产品！`),
        ]),
        showCancelButton: true,
        confirmButtonText: `确认`,
        cancelButtonText: "取消",
        closeOnClickModal: false,
        showInput: true,
        beforeClose: (action, instance, done) => {
          if (action === "confirm") {
            if (instance.inputValue == st || instance.inputValue.indexOf("-")==0) {
              st = instance.inputValue;
              done();
            } else {
              this.$message({
                type: "warning",
                message: `输入错误，请重新输入或取消！`,
              });
            }
          } else {
            done();
          }
        },
      }).then(async () => {
        const res = await apiProductionOrderUnlockDevice({
          id: row.productionOrder.id,
          deviceId: row.id,
          newSn: st
        });
        if (res.code == 0) {
          this.getProductionOrderDevices();
          this.$message({
            type: "success",
            message: res.msg
          });
        }
      });
    },
    // 表格数据
    async getProductionOrderDevices(remove, callback) {
      if (!(remove == "noRemove")) {
        this.tableData = [];
      }
      const res = await apiProductionOrderDevices({
        id: this.tabPaneValue,
        ...this.devicesSearchForm,
        pageNum: this.pagination.currentPage,
        pageSize: this.pagination.pageSize,
        desc: this.desc,
        orderBy: this.orderBy,
      });
      // console.log(res);
      if (res.code == 0) {
        this.tableData = res.data;
        this.pagination.total = res.total;
        this.pagination.beginIndex = res.beginIndex;
        this.pagination.endIndex = res.endIndex;
        if (callback) callback();
      }
    },
    // 表格数据排序
    sortChange({ prop, order }) {
      this.orderBy[0] = prop;
      if (order == "ascending") {
        this.desc = false;
      } else if (order == "descending") {
        this.desc = true;
      } else {
        this.desc = undefined;
        this.orderBy = [];
      }
      this.getProductionOrderDevices();
    },
    // 页码改变
    currentChange(val) {
      this.pagination.currentPage = val;
      this.getProductionOrderDevices();
    },
    // 页容量改变
    sizeChange(val) {
      this.pagination.currentPage = 1;
      this.pagination.pageSize = val;
      this.getProductionOrderDevices();
    },
    // 点击sn列
    SNClickBtn(e, row) {
      e.target.blur();
      this.drawerOption = {
        currentSNId: row.id,
        currentSNName: row.sn,
      }
      this.$nextTick(() => {
        this.$refs.myDrawer.getDeviceLife();
      })
    },
    // 产品列表表格导出
    tableExport(command) {
      this.$confirm(`导出数据可能需要几分钟的时间，确定导出吗？`, `导出${command}`, {
        confirmButtonText: "确定",
        cancelButtonText: "取消",
        type: "warning",
      }).then(async () => {
        let res = {};
        if (command == '发货单报表') {
            res = await apiExportShipmentOrder({
            id: this.tabPaneValue
          });
        } else if (command == '导出MAC') {
          res = await apiExportMacs({
            id: this.tabPaneValue
          });
        } else {
          res = await apiProductionOrderDevices({
            id: this.tabPaneValue,
            ...this.devicesSearchForm,
            export: true,
            desc: this.desc,
            orderBy: this.orderBy,
          });
        }
        if (res.code == 0) {
          this.$downloadFile(res.fid, res.fileName, res.secretKey);
        }
      });
    },
    handleSelectionChange(val) {
      this.multipleSelection = val;
    },
    // 复制单元格内容到剪贴板
    copyCell(row, field, tipKey) {
      const raw = row[field];
      if (raw === null || raw === undefined || raw === "") return;
      const text = typeof raw === "object" ? JSON.stringify(raw, null, 2) : String(raw);
      const showTip = () => {
        this.$set(row, tipKey, true);
        clearTimeout(this.copyTimers[tipKey]);
        this.copyTimers[tipKey] = setTimeout(() => {
          this.$set(row, tipKey, false);
        }, 1500);
      };
      if (navigator.clipboard && window.isSecureContext) {
        navigator.clipboard.writeText(text).then(showTip);
      } else {
        const textarea = document.createElement("textarea");
        textarea.value = text;
        textarea.style.position = "fixed";
        textarea.style.opacity = "0";
        document.body.appendChild(textarea);
        textarea.select();
        document.execCommand("copy");
        document.body.removeChild(textarea);
        showTip();
      }
    }
  },
  beforeDestroy() {
    Object.keys(this.copyTimers).forEach((key) => clearTimeout(this.copyTimers[key]));
  }
};
</script>

<style lang="less" scoped>
.devicesPage {
  height: 100%;
  display: flex;
  flex-direction: column;
}
.item {
  margin-right: 2px;
  margin-left: 2px;
}
.bodyCell {
  position: relative;

  .textOverflow {
    overflow: hidden;
    text-overflow: ellipsis;
    white-space: nowrap;
  }

  .copyBtn {
    display: none;
    position: absolute;
    top: 50%;
    right: 0;
    transform: translateY(-50%);
    padding: 0 2px;
    line-height: 1.2;
    cursor: pointer;
    color: var(--themeColor);
    background-color: var(--bgHover);
    border-radius: 2px;
    transition: color 0.2s, transform 0.2s;

    &:hover {
      color: var(--themeColorDark);
      transform: translateY(-50%) scale(1.2);
    }
  }

  &:hover .copyBtn {
    display: inline-block;
  }
}
</style>
